var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],staticClass:"btn btn-sm effect-zoom"},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])}
var staticRenderFns = []

export { render, staticRenderFns }